export { default } from "./DateText";
